import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Icon, Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

import './newClaimPopup.scss';

export const NewClaimPopup = ({ isOpen, onClose = () => {} }) => {
  /*
  TODO: This should be moved to UI Library for modals
  */
  const modalRef = useRef(null);
  useEffect(() => {
    if (isOpen) {
      modalRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="dialog_label"
      aria-describedby="dialog_desc"
      ref={modalRef}
      tabIndex={-1}
    >
      <Modal
        customCssClass="newClaimPopup"
        size="xsmall"
        isContentScrollable
        showFooterDivider
        open
        onClose={onClose}
        header={
          <h2
            id="dialog_label"
            className="modal-title"
          >
            Before you start
          </h2>
        }
        footer={
          <button
            onClick={() => onClose()}
            type="button"
            className="button primary nextButton"
          >
            <span>Next</span>
          </button>
        }
      >
        <div id="dialog_desc">
          <section>
            <Icon icon="document-generic" />
            {/* eslint-disable-next-line max-len */}
            <p>
              Make sure the <strong>invoice/s you are claiming for are uploaded to the invoice section</strong> (Step 3)
              for faster and accurate claim processing.
            </p>
          </section>
          <section>
            <Icon icon="warning" />
            {/* eslint-disable-next-line max-len */}
            <p>
              <strong>
                IMPORTANT: Invoice/s submitted in Step 4 will be treated as supporting information only and will not be
                included in claim reimbursement calculations.
              </strong>
            </p>
          </section>
        </div>
      </Modal>
    </div>
  );
};

NewClaimPopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
